export default {
  bottomRow: {
    pb: '60px'
  },
  progressLineSize: {
    maxWidth: '600px',
    width: ['91.4666667vw', '91.4666667vw', '65.0510204vw', '65.0510204vw', '100%'],
    margin: '0 auto'
  },
  buttonCenter: {
    display: 'flex',
    justifyContent: 'center'
  }
};